export const init = () => {
  // TRACKER 'SPORTPAGE'
  const sep = AnalyticsConstants.concatenator;
  const fwk = CUBE.Analytics;
  const utils = fwk.utils.sportpage;

  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.sportpage);

  const eventSportNavigationLeft = new AnalyticsClickEvent('sportNavigationLeft', tracker.defaultEvent());
  eventSportNavigationLeft.domContainer = '.sportspage__navigation';
  eventSportNavigationLeft.domElement = '.sportspage__nav-item';
  eventSportNavigationLeft.getLabel = ($element) => {
    const label = `${'ClickNavigationLeft '}${  utils.getNavigationOnLeftName($element)}`;
    return label;
  };
  tracker.addEvent(eventSportNavigationLeft);

  const eventSportProductNavigation = new AnalyticsClickEvent('sportProductNavigation', tracker.defaultEvent());
  eventSportProductNavigation.domContainer = '#sportspage-subcategoriesfloor nav';
  eventSportProductNavigation.domElement = 'a';
  eventSportProductNavigation.getLabel = ($element) => {
    const label = `${'ProductNavigation '}${  utils.getProductNavigationName($element)}`;
    return label;
  };
  tracker.addEvent(eventSportProductNavigation);

  const eventSportAssociatedSport = new AnalyticsClickEvent('sportAssociatedSport', tracker.defaultEvent());
  eventSportAssociatedSport.domContainer = '#sportspage-subcategoriesfloor .associated-content';
  eventSportAssociatedSport.domElement = 'a';
  eventSportAssociatedSport.getLabel = ($element) => {
    const label = `${'AssociatedSport '}${  tc_vars.env_sport  }|${  utils.getAssociatedSportName($element)}`;
    return label;
  };
  eventSportAssociatedSport.postAction(($element) => {
    const st = `associated-${CUBE.Analytics.utils.getInfoNavFromURLForShoppingTool($element.attr('href'))}`;
    fwk.shoppingtool.set('navigation', st);
  });

  tracker.addEvent(eventSportAssociatedSport);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);


};



// WEBPACK FOOTER //
// ./src/analytics/trackers/sportpage/sportpage-tracker.js